
// ExibirVenda.js

import React, { useState, useEffect } from 'react';
import ModalDetalhesCliente from './ModalDetalhesCliente'; // Certifique-se de que o caminho está correto
import ModalExibirItensVenda from './ModalExibirItensVenda'; // Importe o novo modal de consulta aqui
import ModalExibirParcelasVenda from './ModalExibirParcelasVenda'; // Importe o novo modal de consulta aqui
import RelatorioVendasModal from './RelatorioVendasModal'; // Supondo que o modal esteja em outro arquivo
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';

import '../App.css';
import './ModalDetalhesCliente.css';
import './ModalContasAreceber.css';
 
function ExibirVenda({ venda = {}, handleCancelaExibe }) {

  const [detalhesCliente, setDetalhesCliente] = useState(false);
  const [exibirItensVenda, setExibirItensVenda] = useState(false);
  const [itensVenda, setItensVenda] = useState([]);
  const [exibirParcelasVenda, setExibirParcelasVenda] = useState(false);
  const [parcelasVenda, setParcelasVenda] = useState([]);

  const [codVendaParaExibir, setCodVendaParaExibir] = useState("");

  const [formData, setFormData] = useState({
    id: 0,       // Valor inicial para id da venda
    codvenda: '',
    dtvenda: '',
    tipo: '',

    idcliente: 0,  // Estado para armazenar dados do cliente selecionado
    nomecli: '',
    codcli: '',
    cnpjcli: '',

    empresa: '',
    codemp: '',
    cnpjemp: '',

    nfvenda: '',
    valvenda: 0, // Valor inicial para valvenda
    formapag: '',
    condpag: '',
    dtnfvenda: '',

    pesoliqd: 0,
    pesobruto: 0,
    unidade: '',
    entregues: 0,
    devolvidos: 0,
    saldo: 0,

    grupo: '',
    grupodesc: '',
    conta: '',
    contadesc: '',

    romaneio: '',
    placa: '',
    motorista: '',
    ajudante: '',

  });

    useEffect(() => {
    // Atualiza os detalhes da venda quando o componente é montado
    if (venda) {
      setFormData({
      ...venda,
      id: venda.id || 0,               // Certifique-se de armazenar o ID da venda no estado
      idcliente: venda?.cliente?.id || 0,
      nomecli: venda?.cliente?.nomecli || '',
      codcli: venda?.cliente?.codcli || '',
      cnpjcli: venda?.cliente?.cnpjcli || '',
      valvenda: venda.valvenda || 0,  // Atualizando valvenda no estado
      });
      setCodVendaParaExibir(venda.codvenda); // Definir o código da venda para atualizar
    }
  }, [venda]);

  const idVenda = venda ? venda.id : 0; // Captura o 'id' da venda, ou define como 'null' se não houver Venda
  const idCliente = venda ? venda.cliente.id : 0; // Captura o 'id' do Cliente, ou define como 'null' se não houver Cliente


  const fetchItensVenda = (codvenda) => {
    api.get(`/vendasitem/${codvenda}/itens`)

      .then(response => {
        console.log('Itens da venda recebidos:', response.data);
        setItensVenda(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar itens da venda:', error);
      });
  };


  const fetchParcelasVenda = (codvenda) => {
    api.get(`/areceber/${codvenda}/parcelas`)

      .then(response => {
        console.log('Parcelas da venda recebidos:', response.data);
        setParcelasVenda(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar Parcelas da venda:', error);
      });
  };


// Função para abrir ou fechar os detalhes do cliente
  const toggleDetalhesCliente = () => {
    setDetalhesCliente(!detalhesCliente);
  };

  
  // Função para abrir ou fechar o modal de Exibir Itens da Venda
  const toggleExibirItensVenda = (codvenda) => {
    console.log(`toggleExibirItensVenda chamado para venda ${codvenda}`);
    if (!exibirItensVenda && codvenda) {
      setCodVendaParaExibir(codvenda);
      fetchItensVenda(codvenda);
    }
    setExibirItensVenda(!exibirItensVenda);
  };
  
  // Função para abrir ou fechar o modal de Exibir Parcelas da Venda
  const toggleExibirParcelasVenda = (codvenda) => {
    console.log(`toggleExibirParcelasVenda chamado para venda ${codvenda}`);
    if (!exibirParcelasVenda && codvenda) {
      setCodVendaParaExibir(codvenda);
      fetchParcelasVenda(codvenda);
    }
    setExibirParcelasVenda(!exibirParcelasVenda);
  };

  // Função para formatar a data no formato "DD-MM-YYYY"
  const formatarData = (data) => {
    if (!data) return "Data não disponível";
    const partes = data.split('-');
    if (partes.length !== 3) return "Data inválida";
    const [ano, mes, dia] = partes;
    return `${dia}/${mes}/${ano}`;
  };


// Função para formatar o valor de crédito como moeda brasileira
  const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor);
  };


  const [openRelatorioModal, setOpenRelatorioModal] = useState(false);

  const handleOpenRelatorioModal = () => setOpenRelatorioModal(true);
  const handleCloseRelatorioModal = () => setOpenRelatorioModal(false);


  return (

    <div
      style={{
        minHeight: 'calc(100vh - 20px)',
        maxWidth: '900px',
        paddingTop: '10px',
        marginLeft: '0px',
        margin: '0 auto', // Centralizando o container
        textAlign: 'center', // Alinhamento central
      }}>

      <div style={{ marginBottom: '20px'}}>
        <h3>Controle de Vendas</h3>
      </div>

      {/* Campos básicos da Venda */}
      {venda && (  
        
        <div style={{ textAlign: 'left', marginLeft: '20px' }}>

          <div style={{ display: 'flex', marginBottom: '0px' }}>

            <div style={{ width: '100px', marginRight: '20px' }}>
              <label style={{ display: 'block', width: '100px', marginRight: '20px' }}>Venda</label>
              <input type="text" value={venda.codvenda || ''} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
            <div style={{ width: '120px' }}>
              <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data da Venda</label>
              <input type="text" value={formatarData(venda.dtvenda) || ''} readOnly style={{ width: '120px', height: '28px' }} />
            </div>
            <div style={{ width: '160px', marginLeft: '20px' }}>
            <label style={{ display: 'block', width: '160px'  }}>Tipo da Venda</label>
            <input type="text" value={venda.tipo || ''} readOnly style={{ width: '160px', height: '30px' }} />
            </div>
            
            <div style={{ marginLeft: '20px' }}>
              <button className="btn-truncate" title="Detalhes do Cliene"
                onClick={toggleDetalhesCliente} style={{ width: '110px', marginTop: '20px', height: '30px' }}>Cliente</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
              <button onClick={() => toggleExibirItensVenda(venda.codvenda)} style={{ width: '120px', marginTop: '20px', height: '30px' }}>Exibir Itens</button>
            </div>

            <div style={{ marginLeft: '20px' }}>
              <button onClick={() => toggleExibirParcelasVenda(venda.codvenda)} style={{ width: '120px', marginTop: '20px', height: '30px' }}>Exibir Parcelas</button>
            </div>


          </div>

          <div style={{ display: 'flex', marginBottom: '0px' }}>
            <div style={{ marginRight: '20px', width: '420px' }}>
              <label style={{ display: 'block', width: '420px', marginRight: '20px' }}>Cliente</label>
              <input type="text" value={venda.nomecli || ''} readOnly style={{ width: '100%', height: '30px' }} />
               <br />
             </div>
            <div style={{ width: '100px' }}>
              <label style={{ display: 'block', width: '100px', marginBottom: '0px' }} translate="no">Cód. Cliente</label>
            <input type="text" value={venda.codcli || ''} readOnly style={{ width: '100px', height: '30px' }} />
            </div>
            
           <div style={{ width: '150px' }}>
              <label style={{ display: 'block', width: '150px', marginBottom: '0px', marginLeft: '20px' }}>CNPJ Cliente</label>
            <input type="text" value={venda.cnpjcli || ''} readOnly style={{ width: '150px', height: '30px', marginLeft: '20px' }} />
            </div>

            <div style={{ marginLeft: '40px', marginBottom: '0px', marginTop: '5px'  }}>
            <button onClick={handleOpenRelatorioModal}
            style={{ width: '100px', marginLeft: '0px', marginBottom: '0px', marginTop: '20px', height: '30px' }}>
            Relatórios</button>
            </div>

          </div>
          
          <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ marginRight: '20px', width: '420px' }}>
            <label style={{ display: 'block', width: '420px' }}>Empresa</label>
            <input type="text" value={venda.empresa || ''} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
          <div style={{ width: '100px', marginTop: '0px' }}>
              <label style={{ display: 'block', width: '100px', marginTop: '0px' }} translate="no">Cód Empresa</label>
            <input type="text" value={venda.codemp || ''} readOnly style={{ width: '100px', height: '30px' }} />
          </div>            
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ Empresa</label>
            <input type="text" value={venda.cnpjemp || ''} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>
            
          </div>
                   
        <div style={{ display: 'flex', marginTop: '0px' }}>
            
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px', marginBottom: '0px', marginRight: '20px' }}>Nota Fiscal</label>
          <input type="text" value={venda.nfvenda || ''} readOnly style={{ width: '100px', height: '28px' }} />
        </div>

        <div style={{ width: '100px', marginRight: '0px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '100px' }}>Valor Venda</label>
          <input type="text" value={formatarMoeda(venda.valvenda) || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
            
        <div style={{ width: '180px', marginLeft: '20px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '180px' }}>Forma de Pagamento</label>
          <input type="text" value={venda.formapag || ''} readOnly style={{ width: '180px', height: '30px' }} />
        </div>

        <div style={{ width: '240px', marginLeft: '20px', marginBottom: '0px' }}>
          <label style={{ display: 'block', width: '240px' }}>Condição de Pagamento</label>
          <input type="text" value={venda.condpag || ''} readOnly style={{ width: '240px', height: '30px' }} />
        </div>
            
      </div>
          
        <div style={{ display: 'flex', marginBottom: '0px' }}>
            
           <div style={{ width: '120px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '120px', marginBottom: '0px' }} translate="no">Data Nota Fiscal</label>
            <input type="text" value={formatarData(venda.dtnfvenda) || ''} readOnly style={{ width: '120px', height: '28px' }} />
           </div>

          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px' }} translate="no">Peso Liqd.</label>
            <input type="text" value={venda.pesoliqd || 0} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px'  }}>Peso Bruto</label>
            <input type="text" value={venda.pesobruto|| 0} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
          <div style={{ width: '80px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '80px', marginRight: '20px' }}>Unidade</label>
            <input type="text" value={venda.unidade || ''} readOnly style={{ width: '80px', height: '30px' }} />
          </div>
            
          <div style={{ width: '70px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginRight: '20px' }}>Entregue</label>
            <input type="text" value={venda.entregues || 0} readOnly style={{ width: '70px', height: '30px' }} />
          </div>

          <div style={{ width: '70px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '70px', marginRight: '20px' }}>Devolvido</label>
            <input type="text" value={venda.devolvidos|| 0} readOnly style={{ width: '70px', height: '30px' }} />
          </div>
 
          <div style={{ width: '60px', marginRight: '20px' }}>
            <label style={{ display: 'block', width: '60px', marginRight: '20px' }}>Saldo</label>
            <input type="text" value={venda.saldo|| 0} readOnly style={{ width: '60px', height: '30px' }} />
          </div>
        </div>    

      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px' }}>Grupo</label>
          <input type="text" value={venda.grupo || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '180px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '180px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={venda.grupodesc || ''} readOnly style={{ width: '180px', height: '30px' }} />
        </div>
        <div style={{ width: '100px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '100px', marginRight: '20px'  }}>conta</label>
          <input type="text" value={venda.conta || ''} readOnly style={{ width: '100px', height: '30px' }} />
        </div>
        <div style={{ width: '240px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '240px', marginRight: '20px' }}>Descrição</label>
          <input type="text" value={venda.contadesc || ''} readOnly style={{ width: '240px', height: '30px' }} />
        </div>   
      </div>          

      <div style={{ display: 'flex', marginBottom: '0px' }}>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px' }}>Romaneio</label>
          <input type="text" value={venda.romaneio || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '110px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '110px', marginRight: '20px' }}>Veículo</label>
          <input type="text" value={venda.placa || ''} readOnly style={{ width: '110px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px'  }}>Motorista</label>
          <input type="text" value={venda.motorista || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>
        <div style={{ width: '160px', marginRight: '20px' }}>
          <label style={{ display: 'block', width: '160px', marginRight: '20px' }}>Ajudante</label>
          <input type="text" value={venda.ajudante || ''} readOnly style={{ width: '160px', height: '30px' }} />
        </div>   
          </div>    
          
      {detalhesCliente && venda?.cliente && (
        <ModalDetalhesCliente cliente={venda.cliente} fecharDetalhes={toggleDetalhesCliente} />
      )}
          
      {exibirItensVenda && (
        <ModalExibirItensVenda
          isOpen={exibirItensVenda}
          fecharModal={toggleExibirItensVenda}
          codVenda={codVendaParaExibir}
          itensVenda={itensVenda}
        />
          )}
          
          
      {exibirParcelasVenda && (
        <ModalExibirParcelasVenda
          isOpen={exibirParcelasVenda}
          fecharModal={toggleExibirParcelasVenda}
          codVenda={codVendaParaExibir}
          parcelasVenda={parcelasVenda}
        />
      )}

            <RelatorioVendasModal
          open={openRelatorioModal}
          handleClose={handleCloseRelatorioModal}
          idVenda={idVenda}  // Passa o ID da Venda para o Modal
          codVenda={formData.codvenda}  // Passa o Código do Cliente para o Modal
          idCliente={idCliente}  // Passa o ID do Cliente para o Modal
          codCli={formData.codcli}  // Passa o Código do Cliente para o Modal
        />

                
    </div>
      )}
      
  

  <br />
    
    <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
        <button type="button" className='btn-menu' onClick={handleCancelaExibe}
          style={{ width: '150px', height: '30px', padding: '0px 0px', color: 'inherit' }}>Fechar Vendas
        </button>
      </div>
    </Box>

  <br />
      
  </div>
    
  );
}  
  
export default ExibirVenda;